import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const SetorCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    nome: "",
    nome_in: "",
    nome_es: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-setor").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/setor", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/setor");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o setor.");
    }
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(`/setor/${location.state.id}`);

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        setState(data.data);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do setor");
      }
    };

    let validacao = window.$("#form-setor").validate(validate);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Setores"
        header="Cadastro da Setores"
        action={{ titulo: "Voltar", link: "/setor" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do setor</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-setor">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome do setor</label>
                                          <input
                                            type="text"
                                            placeholder="Nome do setor"
                                            className="form-control"
                                            name="nome"
                                            value={state.nome}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome do setor</label>
                                          <input
                                            type="text"
                                            placeholder="Nome do setor"
                                            className="form-control"
                                            name="nome_in"
                                            value={state.nome_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome do setor</label>
                                          <input
                                            type="text"
                                            placeholder="Nome do setor"
                                            className="form-control"
                                            name="nome_es"
                                            value={state.nome_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default SetorCadastrar;
